function initLoading() {
  const l = document.createElement("div");
  l.id = "loadingEl";
  l.classList.add("loading");
  l.innerHTML = `
    <div class="loading-spinner"></div>
    <div class="loading-text">加载中...</div>
  `;
  document.body.appendChild(l);
}
initLoading();

export function showLoading(config = { text: "加载中...", timeout: 0 }) {
  // console.log("showLoading", config);
  const l = document.getElementById("loadingEl");
  if (l) {
    l.classList.add("show");
  }

  const text = typeof config === "string" ? config : config.text;
  if (text) {
    const t = l.querySelector(".loading-text");
    if (t) {
      t.innerText = text;
    }
  }

  if (config.timeout > 0) {
    clearTimeout(window.__loading_timeout__);
    window.__loading_timeout__ = setTimeout(hideLoading, config.timeout);
  }
}

export function hideLoading() {
  const l = document.getElementById("loadingEl");
  if (l) {
    l.classList.remove("show");
  }
}

export default {
  show: showLoading,
  hide: hideLoading,
};
